export default {
  premadeBudgets: [{
    label: '$50,000',
    value: '50000',
    description: 'A luxurious big budget wedding with no expense spared'
  }, {
    label: '$40,000',
    value: '40000',
    description: 'A big budget wedding with generious overall allocations'
  }, {
    label: '$30,000',
    value: '30000',
    description: 'The average wedding bugdet accross all U.S. states'
  }, {
    label: '$20,000',
    value: '20000',
    description: 'A lower budget wedding with economical amounts'
  }, {
    label: '$15,000',
    value: '15000',
    description: 'A smaller budget wedding with restricted allocations'
  }, {
    label: '$10,000',
    value: '10000',
    description: 'A small budget wedding with tighter cost restrictions'
  }, {
    label: '$5,000',
    value: '5000',
    description: 'A very small budget wedding with only the essentials'
  }, {
    label: '$1,000',
    value: '1000',
    description: 'A shoe-string budget containing only the "must haves"'
  }],
  desiredBudgetQuestion: 'i-yYoFn5b-NyMpw0V5kvg',
  questionBudgetAllocations: [{
    id: '6NkhAOR8d1a7S13-IxQEt',
    name: 'Wedding Planner',
    category: 'planning',
    amounts: {
      '1000': 0,
      '5000': 0,
      default: 4
    }
  }, {
    id: 'JbOwaxoz84LLGAHPtpO_n',
    name: 'Planning Materials',
    category: 'planning',
    amounts: {
      default: 0
    }
  }, {
    id: 'JuaBEzj0LEQml9o7CMg7J',
    name: 'Stationary',
    category: 'invitations',
    amounts: {
      '1000': 0,
      '5000': 0,
      default: 0.25
    }
  }, {
    id: 'BEEoKFDfUM_mZsdFBWeVu',
    name: 'Guest Invitations',
    category: 'invitations',
    amounts: {
      '1000': 5,
      '5000': 2,
      default: 0.75
    }
  }, {
    id: 'MdLm9jll0YTMmHNW83E0l',
    name: 'Thank You Cards',
    category: 'invitations',
    amounts: {
      default: 0
    }
  }, {
    id: 'E892dqhGFGFrum2PWBfD_',
    name: "Bride's Ring",
    category: 'rings',
    amounts: {
      '1000': 15,
      '5000': 9,
      default: 3
    }
  }, {
    id: 'bvxR9NQllcguRMD-EKrpy',
    name: "Groom's Ring",
    category: 'rings',
    amounts: {
      '1000': 5,
      '5000': 3,
      default: 1
    }
  }, {
    id: 'Et1GHdwSNn9TExcd4YnTc',
    name: 'Ceremony Venue',
    category: 'venue',
    amounts: {
      '1000': 0,
      '5000': 10,
      default: 10
    }
  }, {
    id: '_4HO3IxVm9GSbw3Q33s7T',
    name: 'Ceremony Decor',
    category: 'venue',
    amounts: {
      '1000': 0,
      '5000': 0,
      default: 1
    }
  }, {
    id: 'PN0303a-oRZLBFewCJH3k',
    name: 'Reception Venue',
    category: 'venue',
    amounts: {
      '1000': 0,
      '5000': 15,
      default: 10
    }
  }, {
    id: 'c5pzYMJyJDXUsfgSPlJ-e',
    name: 'Reception Decor',
    category: 'venue',
    amounts: {
      '1000': 0,
      '5000': 0,
      default: 1
    }
  }, {
    id: 'spIN-MeB0EN4N-PTDa_Mi',
    name: 'Rehersal Dinner Venue',
    category: 'venue',
    amounts: {
      '1000': 0,
      '5000': 0,
      default: 4
    }
  }, {
    id: '41hmUjntYKUiyLc0mAj4x',
    name: 'Meals & Service',
    category: 'catering',
    amounts: {
      '1000': 25,
      '5000': 17,
      default: 14
    }
  }, {
    id: 'wkJc-hxaF3Z_lZgGttXOt',
    name: 'Bartenders',
    category: 'catering',
    amounts: {
      '1000': 0,
      '5000': 0,
      default: 5
    }
  }, {
    id: 'Xo6Nf--ls8jt5hSVxON7i',
    name: 'Performing Band',
    category: 'band',
    amounts: {
      '1000': 0,
      '5000': 0,
      default: 10
    }
  }, {
    id: 'cfLGBqrqw0LtWCrck544e',
    name: 'Extra Expenses',
    category: 'band',
    amounts: {
      default: 0
    }
  }, {
    id: 'MV8z-3pofjPrEodlvzIMI',
    name: 'Photographer',
    category: 'photography',
    amounts: {
      '1000': 20,
      '5000': 10,
      default: 6
    }
  }, {
    id: 'SjtjT6uqd3jiC8TOsk4xD',
    name: 'Custom Prints',
    category: 'photography',
    amounts: {
      default: 0
    }
  }, {
    id: 'j8k8tfHrmklyuY7JjFb1o',
    name: 'Wine & Beer',
    category: 'alcohol',
    amounts: {
      '1000': 0,
      '5000': 0,
      default: 2
    }
  }, {
    id: 'QEvYcR57eU-OjwT9euvyX',
    name: 'Spirits & Liqour',
    category: 'alcohol',
    amounts: {
      '1000': 0,
      '5000': 0,
      default: 4
    }
  }, {
    id: 'GqwKGjzr0y-n_jGBHeLsK',
    name: 'Ceremony Flowers',
    category: 'flowers',
    amounts: {
      '1000': 0,
      '5000': 4,
      default: 3
    }
  }, {
    id: 'mjRIuZ540WJuMhFk3a_qc',
    name: 'Reception Flowers',
    category: 'flowers',
    amounts: {
      '1000': 0,
      '5000': 0,
      default: 2
    }
  }, {
    id: 'U731kthakt9MLbycOwk4Q',
    name: "Bride's Bouquet",
    category: 'flowers',
    amounts: {
      '1000': 0,
      '5000': 2,
      default: 1
    }
  }, {
    id: 'BiKZUeofxkQdtIJx22DFX',
    name: 'Bridesmaids Bouquets',
    category: 'flowers',
    amounts: {
      default: 0
    }
  }, {
    id: 'puacCB837j3-zMT9knLp1',
    name: 'Groomsman Boutonnieres',
    category: 'flowers',
    amounts: {
      default: 0
    }
  }, {
    id: 'H25wKbAcm3fI5euNwvH8u',
    name: 'Flower Girl Flowers',
    category: 'flowers',
    amounts: {
      default: 0
    }
  }, {
    id: 'Bmsflkl7nenz7obPYQlzB',
    name: 'Other Bouquet / Boutonnieres',
    category: 'flowers',
    amounts: {
      default: 0
    }
  }, {
    id: 'MpWdvboKwvQYp3KgdmO-M',
    name: 'Videographer',
    category: 'videography',
    amounts: {
      '1000': 0,
      '5000': 0,
      default: 5
    }
  }, {
    id: 'bkEC1tpP-lJ38ERPPeiRK',
    name: 'Extra Expenses',
    category: 'videography',
    amounts: {
      default: 0
    }
  }, {
    id: 'XzE5r8Pp7EEDlQ3nw2Rah',
    name: 'Wedding Dress',
    category: 'dress-and-attire',
    amounts: {
      '1000': 20,
      '5000': 9,
      default: 4
    }
  }, {
    id: 'bi-8hbgjKUuUDuif12_37',
    name: 'Headpiece & Veil',
    category: 'dress-and-attire',
    amounts: {
      '1000': 0,
      '5000': 1,
      default: 0.5
    }
  }, {
    id: 'ZLKwuwOJX29wxyQtWcEry',
    name: "Groom's Suit / Tux",
    category: 'dress-and-attire',
    amounts: {
      '1000': 0,
      '5000': 2,
      default: 0.5
    }
  }, {
    id: 'NlOw_us4hlWAIrzy7_7Xg',
    name: 'Accessories',
    category: 'dress-and-attire',
    amounts: {
      default: 0
    }
  }, {
    id: 'UAhSoInDA8cXf_8jh0K2R',
    name: 'DJ',
    category: 'dj-and-music',
    amounts: {
      '1000': 0,
      '5000': 10,
      default: 3
    }
  }, {
    id: 'QWEoTnU5LOVWR8DYKWmo5',
    name: 'Ceremony Music',
    category: 'dj-and-music',
    amounts: {
      default: 0
    }
  }, {
    id: 'DpqYpRVxx0YHXtK0XlwPg',
    name: 'Wedding cake',
    category: 'cake',
    amounts: {
      '1000': 10,
      '5000': 4,
      default: 1
    }
  }, {
    id: 'hF4Tu3_J-R2AQhU6ZpAo_',
    name: 'Extra Expenses',
    category: 'cake',
    amounts: {
      default: 0
    }
  }, {
    id: 'gcLpQHkQWfnxHPXQIVEBY',
    name: 'Guest Gifts',
    category: 'favors-and-gifts',
    amounts: {
      '1000': 0,
      '5000': 0,
      default: 1
    }
  }, {
    id: '3Y5evBYbLnpVyapr64WJm',
    name: 'Extra Expenses',
    category: 'favors-and-gifts',
    amounts: {
      default: 0
    }
  }, {
    id: 'nLwUUD8AF75sX-lWSlQmH',
    name: 'Guest Transportation',
    category: 'transportation',
    amounts: {
      '1000': 0,
      '5000': 0,
      default: 1
    }
  }, {
    id: '28VBgQKwp7sYT90xNNtLK',
    name: 'Limo Rental',
    category: 'transportation',
    amounts: {
      '1000': 0,
      '5000': 0,
      default: 1
    }
  }, {
    id: 'yZHsLHy4YsY1AqGwZRXVD',
    name: 'Hair / Makeup',
    category: 'beauty-and-wellness',
    amounts: {
      '1000': 0,
      '5000': 2,
      default: 1
    }
  }, {
    id: 'tZfj4uUoUJ7dUDp2zUEap',
    name: 'Extra Expenses',
    category: 'beauty-and-wellness',
    amounts: {
      default: 0
    }
  }, {
    id: '9-P3CyAySbw_iaA25HFhd',
    name: 'Officiant Services',
    category: 'officiant',
    amounts: {
      default: 0
    }
  }, {
    id: 'hTY40j99KugyLufgOTkIN',
    name: 'Extra Expenses',
    category: 'officiant',
    amounts: {
      default: 0
    }
  }, {
    id: 'VYLAn2qFLjf-AaC9zotsU',
    name: 'Guest Entertainment',
    category: 'other',
    amounts: {
      default: 0
    }
  }, {
    id: 'JJaG2gr6bEUPbD-Iivef2',
    name: 'Equipment Rentals',
    category: 'other',
    amounts: {
      default: 0
    }
  }, {
    id: '1JHcLoQeo8zy9brfepJzV',
    name: 'Wedding Party Gifts',
    category: 'other',
    amounts: {
      default: 0
    }
  }, {
    id: 'CPZumRfz31H_h6oG5Qaod',
    name: 'Guest Accommodations',
    category: 'other',
    amounts: {
      default: 0
    }
  }, {
    id: 'MjpX-ZfTX3UX3LbkfcY3B',
    name: 'Other Accommodations',
    category: 'other',
    amounts: {
      default: 0
    }
  }, {
    id: 'QsVsXin-o2y6p6mxSZvVC',
    name: 'Extra Expenses',
    category: 'other',
    amounts: {
      default: 0
    }
  }]
};